import React, { useEffect, useState } from "react";
import styles from "./About.module.css";
import HeadBar from "../headBar/HeadBar";
import PageHeader from "../../pageheader/PageHeader";
import bg1 from "../../../asset/image/new/bg1.png";
import logo from "../../../asset/image/new/logo.png";
import "./About.module.css";
import people from "../../../asset/image/new_people_about.png";
import doctor from "../../../asset/image/new_doctor_about.png";

import staff from "../../../asset/image/new_staff_about.png";

// import DMSC_default from "../../../asset/new/DMSC_default.png";
import Footer from "../footer/Footer";
import MenuAdmin from "../../admin/navAdmin/Menu";
//import Breadcrumb from "../../breadcrumb/breadcrumb";
import Breadcrumb from "../breacrumb/breadcrumb";

const dataCardContentAbout = [
  {
    src: `${people}`,
    titleText: "ประชาชน",
    contentText: "ผู้ที่รับผลการตรวจไปใช้ในการปรึกษาแพทย์หรือเภสัชกร ",
  },
  {
    src: `${doctor}`,
    titleText: "แพทย์หรือเภสัชกร",
    contentText: "สามารถเข้าถึงข้อมูลการตรวจทางพันธุกรรมของผู้ป่วย",
  },
  {
    src: `${staff}`,
    titleText: "เจ้าหน้าที่ห้องปฏิบัติการ",
    contentText:
      "ผู้ลงทะเบียนห้องปฏิบัติการตรวจ หรืออนุมัติให้ผู้ปฏิบัติงานในห้องปฏิบัติการ สามารถลงผลการตรวจทางห้องปฏิบัติการได้",
  },
];

function About({ disabledMenu, role }) {
  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: "เกี่ยวกับเรา", url: `${role ?? ""}/about` },
  ];
  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={"เกี่ยวกับเรา"} btnBackWard={false} />
        <div>
          แพลตฟอร์มดิจิทัลผูกพันธุ์
          เป็นระบบที่ช่วยให้คุณสามารถเข้าถึงผลการตรวจทางพันธุกรรมได้
          ไม่ว่าคุณจะเคยตรวจที่โรงพยาบาลหรือสถานพยาบาลใดใด
          ผ่านเว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
        </div>
        <div className="flex gap-6 my-8">
          <div className="w-[300px]">
            <img src={bg1} className="w-full" alt={`รูปประกอบแพลตฟอร์มดิจิทัลผูกพันธุ์`}/>
          </div>
          <div className="w-[300px] border rounded-md flex justify-center items-center">
            <img src={logo} className="w-[160px]" alt={`รูปประกอบแอปพลิเคชันผูกพันธุ์`}/>
          </div>
        </div>
        <div className="mb-10">
          ตรวจเพียงครั้งเดียวใช้ผลได้ตลอดชีวิต
          เนื่องจากผลการตรวจทางพันธุกรรมส่วนมากตรวจเพียงครั้งเดียว
          จะสามารถใช้ผลได้ตลอดชีวิต ไม่จําเป็นต้องตรวจซ้ํา
          ดังนั้นเพื่อไม่ให้เสียค่าใช้จ่ายโดยไม่จําเป็น คุณสามารถนําผลการ
          ตรวจทางพันธุกรรมไปแสดงให้แพทย์เพื่อใช้ในการประกอบการรักษาได้
        </div>
        <div className="mb-10">
          ผลการทดสอบแรกที่แสดงใน "ผูกพันธุ์"
          เนื่องจากกรมวิทยาศาสตร์การแพทย์มีห้องปฏิบัติการตรวจเภสัชพันธุศาสตร์ 4
          การทดสอบ
          <ul className="list-none">
            <li>
              การตรวจ HLA-B*58:01 สําหรับกลุ่มผู้ป่วยที่ได้รับยา Allopurinol
            </li>
            <li>
              การตรวจ HLA-B*15:02 สําหรับกลุ่มผู้ป่วยที่ได้รับยา Carbamazepine
            </li>
            <li>การตรวจ HLA-B*57:01 สําหรับกลุ่มผู้ป่วยที่ได้รับยา Abacavir</li>
            <li>
              การตรวจยีนย่อยสลายยา NAT2 ในผู้ป่วยโรควัณโรคที่ได้รับยา Isoniazid
            </li>
            <li>
              การตรวจ HLA-A*31:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Carbamazepine
            </li>
            <li>
              การตรวจ HLA-B*13:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Dapsone
            </li>
          </ul>
        </div>
        <div className="mb-10">
          และการทดสอบทางพันธุกรรมอื่น ๆ เช่น การตรวจการกลายพันธุ์ของยีน
          BRCA1/BRCA2 การตรวจธาลัสซีเมีย
          และการแปลผลทางพันธุกรรมจากโครงการจีโนมิกส์ประเทศไทย เป็นต้น
          โดยจะส่งผลการตรวจกลับไปที่โรงพยาบาลที่ส่งตรวจเท่านั้น
          ข้อมูลจะไม่ถูกส่งข้ามโรงพยาบาล
          ทําให้ผู้ป่วยที่อาจมียีนเสี่ยงต่อการแพ้ยา มีโอกาสเสี่ยงเกิดการแพ้ยาได้
          ดังนั้น “ผูกพันธุ์” จึงถูกพัฒนาขึ้น และมีผู้ใช้งานหลัก 3 ประเภท ได้แก่
        </div>
        <div className="grid lg:grid-cols-1 grid-cols-3 gap-6">
          {dataCardContentAbout.map((item, index) => (
            <CardContentAbout
              key={index}
              src={item.src}
              titleText={item.titleText}
              contentText={item.contentText}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default About;

export function CardContentAbout({ key, titleText, contentText, src }) {
  return (
    <>
      <div className="flex flex-col items-center" id={key}>
        <div className="w-full bg-[#E6F5FC] rounded-xl p-4 flex justify-center lg:h-auto h-[408px]">
          <img src={src} alt={`รูปประกอบ ${titleText}`}/>
        </div>
        <div className="w-full">
          <h1 className="text-[1.25rem] font-bold my-2">{titleText}</h1>
          <p>{contentText}</p>
        </div>
      </div>
    </>
  );
}
